import { TFunction } from 'i18next';
import { camelCase } from 'lodash-es';

import { catalogNameValues, searchNameValues } from '../models/filter';

export const getSortOptions = (isSearchResultPage: boolean, t: TFunction) => {
  const values = isSearchResultPage ? searchNameValues : catalogNameValues;
  return values.map((sort) => ({
    label: t(`catalog.sort.${camelCase(sort)}`),
    value: sort,
  }));
};
